import { takeLatest, put } from 'redux-saga/effects';
import moment from 'moment';

import { storage } from '@commons/storage';

import {
  CONFIG_SESSION,
  evolucaoAnimal,
  NEW_EVOLUCAO_ANIMAL,
  NEW_EVOLUCAO_ANIMAL_SUCCESS,
} from '@handler';

function* sagaNewEvolucaoAnimal(action) {

  yield put({ type: NEW_EVOLUCAO_ANIMAL_SUCCESS, registro: 
    {
      ...evolucaoAnimal.newRegistro,
      data: moment().startOf('day').format('YYYY-MM-DD'),
      anoPecuario: JSON.parse(storage.get(CONFIG_SESSION)).anoPecuarioAtivo,
    } });
}

export default function* watchNewEvolucaoAnimal() {
  yield takeLatest(NEW_EVOLUCAO_ANIMAL, sagaNewEvolucaoAnimal)
}
